module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Caleb Warnock\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Caleb Warnock is the popular author of"), _c('I', [_vm._v(" Forgotten Skills of Self-Sufficiency, The Art of Baking with Natural Yeast, Backyard Winter Gardening For All Climates, More Forgotten Skills, Trouble's On The Menu,")]), _vm._v(" and the Backyard Renaissance Collection. He is the owner of SeedRenaissance.com and blogs at CalebWarnock.blogspot.com, where you will find a link to join his email list to learn more about forgotten skills. ")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/XFPwcG/tc-custom/9781944822569.jpg?1705348423178",
      "alt": "This image is the cover for the book Successful Gardening In Utah, The Backyard Renaissance Collection"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Successful Gardening In Utah, The Backyard Renaissance Collection\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The author of "), _c('i', [_vm._v("Forgotten Skills of Self-Sufficiency")]), _vm._v(" shares the secrets to maintaining an abundant garden in the Rocky Mountain West.")]), _c('br'), _c('br'), _vm._v("Gardening in Utah is unlike gardening anywhere else. Lack of summer rain, daytime heat, and insect infestation are just a few of the challenges we often face in the high desert climate. But Caleb Warnock offers simple solutions to these and many other issues in this accessible guide written specifically for gardening in the Beehive State."), _c('br'), _c('br'), _vm._v("Using his decades of self-sufficiency experience, Caleb makes Utah gardening easy enough for anyone to have a successful harvest. In this volume he covers:How to solve your garden problems once and for allHow to have a low-water garden in one of the driest climates in the USHow to easily keep your garden 95% weed-free!\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Familius LLC\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0